module.exports = __webpack_public_path__ + "img/demand_bg.da5778a.png";